import { Controller } from '@hotwired/stimulus'

export class EquipmentTypeCardController extends Controller {
  static targets = [
    'image',
    'name',
    'serialNumber',
    'serialNumberContainer',
    'sku',
    'skuContainer',
  ]

  declare readonly imageTarget: HTMLImageElement
  declare readonly nameTarget: HTMLElement
  declare readonly serialNumberTarget: HTMLElement
  declare readonly serialNumberContainerTarget: HTMLElement
  declare readonly skuTarget: HTMLElement
  declare readonly skuContainerTarget: HTMLElement

  updateEquipmentTypeId({ detail: { value } }) {
    if (value) {
      fetch(`/device_types/${value}.json`)
        .then((resp) => resp.json())
        .then(({ device_type: deviceType }) => {
          this.imageTarget.src = deviceType.image
          this.nameTarget.innerHTML = deviceType.identifier

          if (deviceType.manufacturer_sku) {
            this.skuContainerTarget.classList.remove('hidden')
            this.skuTarget.innerHTML = deviceType.manufacturer_sku
          } else {
            this.skuContainerTarget.classList.add('hidden')
            this.skuTarget.innerHTML = ''
          }

          this.element.classList.remove('hidden')
        })
    } else {
      this.element.classList.add('hidden')
    }
  }

  updateSerialNumber({ detail: { value } }) {
    if (value) {
      this.serialNumberContainerTarget.classList.remove('hidden')
      this.serialNumberTarget.innerHTML = value
    } else {
      this.serialNumberContainerTarget.classList.add('hidden')
      this.serialNumberTarget.innerHTML = ''
    }
  }
}
